import {AttrsSchema, Component, h} from 'panel';
import MarkdownIt from 'markdown-it';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {MarkdownAttrs} from './types';

export class Markdown extends Component<EmptyObj, MarkdownAttrs> {
  converter: any;

  static get attrsSchema(): AttrsSchema<MarkdownAttrs> {
    return {
      ...super.attrsSchema,
      text: {type: `string`, description: `Markdown formatted text to be processed and rendered as HTML`},
    };
  }

  get config() {
    return {
      template: () => h(`div`),
      defaultState: {},
      helpers: {},
    };
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    if (!this.initialized) {
      return;
    }
    if (attr === `text`) {
      // The markdown library we're using handles the sanitization for us.
      // eslint-disable-next-line no-unsanitized/property
      this.el.children[0].innerHTML = this.getMarkup();
    }
  }

  connectedCallback() {
    super.connectedCallback();
    // The markdown library we're using handles the sanitization for us.
    // eslint-disable-next-line no-unsanitized/property
    this.el.children[0].innerHTML = this.getMarkup();
  }

  constructor() {
    super();
    this.converter = new MarkdownIt();
  }

  getMarkup() {
    return this.converter.render(this.attr(`text`)).trim();
  }
}

export const MarkdownEl = defineAndMakeJsxFactory(`mp-markdown`, Markdown);
